import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Blog3 = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const calculateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrollTop = window.scrollY;
      const progress = (scrollTop / documentHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', calculateScrollProgress);
    return () => window.removeEventListener('scroll', calculateScrollProgress);
  }, []);

  return (
    <article className="blog-article">
      <div className="progress-bar-container">
        <div 
          className="progress-bar"
          style={{ width: `${scrollProgress}%` }}
        />
      </div>

      <Link to="/blogs" className="back-link">
        <span className="mr-2">←</span>
        Terug naar blogs
      </Link>

      <header className="blog-header">
        <div>
          <h1 className="text-3xl font-bold text-[#2B4055] mb-2">Requirements & Pragmatisme</h1>
          <h2 className="text-xl text-[#FF6B35] mb-4">De juiste balans vinden</h2>
          <div className="flex items-center gap-4 text-gray-600">
            <span>10 maart 2024</span>
            <span>•</span>
            <span>6 min leestijd</span>
          </div>
        </div>
      </header>

      <div className="prose">
        <p className="lead">
          Requirements zijn essentieel, maar kunnen ook verlammend werken als ze te rigide 
          worden toegepast. Als Business Analist heb ik geleerd dat de kunst ligt in het 
          vinden van de juiste balans tussen volledigheid en pragmatisme.
        </p>

        <h2>De valkuil van perfectie</h2>
        <p>
          Te vaak zien we dat het streven naar perfecte requirements leidt tot vertraging 
          en frustratie. Het is belangrijk te beseffen dat requirements een middel zijn 
          om waarde te leveren, geen doel op zich.
        </p>

        <h2>Pragmatisch requirements management</h2>
        <p>
          Een pragmatische aanpak betekent niet dat we concessies doen aan kwaliteit. 
          Het betekent dat we slim omgaan met prioriteiten en accepteren dat requirements 
          zich ontwikkelen naarmate we meer leren.
        </p>

        <blockquote>
          "De beste requirements zijn niet de meest volledige, maar degene die de meeste 
          waarde opleveren met de minste complexiteit."
        </blockquote>

        <h2>Best practices voor balans</h2>
        <ul>
          <li>
            <strong>Start met het doel:</strong> Begrijp waarom we iets bouwen
          </li>
          <li>
            <strong>Iteratief werken:</strong> Begin klein en bouw incrementeel
          </li>
          <li>
            <strong>Valideer vroeg:</strong> Test aannames met stakeholders
          </li>
          <li>
            <strong>Documenteer slim:</strong> Focus op wat echt belangrijk is
          </li>
        </ul>

        <h2>De rol van stakeholders</h2>
        <p>
          Goede requirements ontstaan in samenwerking met stakeholders. Het is essentieel 
          om de juiste vragen te stellen en actief te luisteren naar de behoeften achter 
          de wensen. Door stakeholders vroeg en vaak te betrekken, voorkom je dat requirements 
          te ver af komen te staan van de praktijk.
        </p>

        <h2>Technieken voor pragmatisch requirements management</h2>
        <p>
          User stories, story mapping en prototype testing zijn effectieve manieren om 
          requirements behapbaar te houden. Deze technieken helpen om de focus te houden 
          op waarde voor de eindgebruiker en maken het mogelijk om snel bij te sturen 
          wanneer nodig.
        </p>

        <h2>Conclusie</h2>
        <p>
          De sleutel tot succes ligt niet in het schrijven van perfecte requirements, 
          maar in het vinden van de juiste balans tussen detail en flexibiliteit. 
          Door pragmatisch te werk te gaan, kunnen we sneller waarde leveren zonder 
          concessies te doen aan kwaliteit. Het gaat erom de juiste vragen te stellen, 
          actief te luisteren en samen met stakeholders te werken aan oplossingen die 
          echt waarde toevoegen.
        </p>
      </div>
    </article>
  );
};

export default Blog3;